// extracted by mini-css-extract-plugin
export default {"slide":"XZmF2","cnSlide":"TdKbk","selected":"S5eXF","parameter":"Xs1sF","video":"wnIcO"};